import React from "react";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { PanelMessageType } from "../../redux/feature/panelMessage/panelMessage-slice";

export const ConfirmationModal = (props: MessagePanelProps) => {
  return <MessagePanel {...props} />;
};

export const NotCompatibleWithWeb = () => {
  return (
    <ConfirmationModal
      message={formatMessage("cof.base.notcompatiblewithweb")}
      imageSrc={"/assets/notCompatible.svg"}
    />
  );
};

export interface MessagePanelProps {
  caption?: string;
  alt?: string;
  message: string;
  messageType?: PanelMessageType;
  imageSrc: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export const MessagePanel = ({ imageSrc, alt, message, messageType, caption, style, children }: MessagePanelProps) => {
  //   todo: moveobject.tsx optimization
  return (
    <div
      style={{
        width: "100vw",
        height: "calc(100vh - 5rem)",
        position: "fixed",
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "var(--color-lightblue)",
        zIndex: 1000000,
        ...style,
      }}
    >
      {caption && (
        <div
          style={{
            backgroundColor: "var(--color-yellow-a20)",
            fontSize: "1rem",
            margin: "1.25rem 1.25rem 1.25rem 1.25rem",
            padding: "0.5rem 1.25rem 0.5rem 1.25rem",
          }}
        >
          {caption}
        </div>
      )}
      <img
        src={imageSrc}
        alt={alt}
        style={{
          minWidth: "120px",
          width: "calc(100vw - 4rem)",
          height: "40vh",
          objectFit: "contain",
        }}
      />
      <span
        id={messageType}
        style={{
          textAlign: "center",
          color: "var(--color-blue)",
        }}
      >
        {message}
      </span>
      {children}
    </div>
  );
};
